module.exports = __webpack_public_path__ + "img/youxiang.cc385cff.png";